export const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ"